export const DataAreas = [
  {
    'id': 1,
    'name': 'Careers'
  },
  {
    'id': 2,
    'name': 'English'
  },
  {
    'id': 3,
    'name': 'Development and Engineering'
  },
  // {
  //   'id': 4,
  //   'name': 'Design and UX'
  // },
  // {
  //   'id': 5,
  //   'name': 'Marketing'
  // },
  {
    'id': 6,
    'name': 'Marketing'
  },
  {
    'id': 7,
    'name': 'Sciences'
  },
  {
    'id': 8,
    'name': 'Business and Entrepreneurship'
  },
  // {
  //   'id': 9,
  //   'name': 'Audiovisual Production'
  // },
  {
    'id': 10,
    'name': 'Professional Growth'
  },
  {
    'id': 11,
    'name': 'Startups'
  },
  {
    'id': 12,
    'name': 'Other'
  }
];